/**
 * @prettier
 * @flow
 */
export const Environments = Object.freeze({
    LOCALHOST: 'LOCALHOST',
    TEST: 'TEST',
    PROD: 'PROD',
});

export type Environment = $Values<typeof Environments>;
